import React from "react";
import { formatearFecha } from "../../../../helpers/formatearFecha";
import { ListaAlcance } from "../../../components/ListaAlcance";

// Los motivos impiden cerrar; las advertencias solo informan qué producción
// alcanzada por la fecha de corte queda para el siguiente cierre
const AvisosAlcance = ({ titulo, avisos, variante }) => {
    if (!avisos.length) return null;

    return (
        <div className={`alert ${variante} mt-2 mb-0`}>
            <strong>{titulo}</strong>
            <ul className="mb-0 mt-1">
                {avisos.map((aviso) => (
                    <li key={aviso}>{aviso}</li>
                ))}
            </ul>
        </div>
    );
};

// Qué abarcaría el cierre con la fecha de corte elegida, qué le falta para
// poder registrarse y qué queda para el siguiente cierre
export const AlcanceCierre = ({ hook }) => {
    const alcance = hook.previsualizacion;

    if (!alcance) return null;

    // sin comparativo no hay cifras que congelar, aunque el alcance esté limpio
    const puedeCerrar = alcance.puede_cerrar && hook.hayComparativo;

    return (
        <div className="comparativo-mensual__alcance">
            <div className="d-flex align-items-center flex-wrap">
                <h5 className="comparativo-mensual__seccion-titulo">
                    Periodo a cerrar
                </h5>

                <div className="d-flex ml-auto gap-10">
                    <button
                        className="btn btn-secondary"
                        onClick={hook.descargarExcel}
                        disabled={hook.cargando || !hook.hayComparativo}
                    >
                        Exportar a Excel
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={hook.cerrarPeriodo}
                        disabled={!puedeCerrar || hook.cargando}
                    >
                        Cerrar periodo
                    </button>
                </div>
            </div>

            <div className="formulario-fields-row my-2">
                <ListaAlcance
                    titulo="Semanas de producción incluidas"
                    items={alcance.semanas.map(
                        (semana) => `${semana.etiqueta} (${semana.rango})`,
                    )}
                    vacio="No hay semanas completas para incluir"
                />

                <ListaAlcance
                    titulo="Periodos de inventario de almacén incluidos"
                    items={alcance.periodos.map((periodo) => periodo.periodo)}
                    vacio={`No hay periodos cerrados que terminen el ${formatearFecha(alcance.fecha_corte)} o antes`}
                />
            </div>

            <AvisosAlcance
                titulo="No se puede cerrar el periodo todavía:"
                avisos={alcance.motivos}
                variante="alert-danger"
            />

            <AvisosAlcance
                titulo="Pendiente para el siguiente cierre:"
                avisos={alcance.advertencias}
                variante="alert-warning"
            />
        </div>
    );
};
